import React from 'react';

import VulnerabilityReportContainer from '@totem/components/software/vulnerabilityReport/vulnerabilityReportContainer';
import VulnerabilityReportLayout from '@totem/components/software/vulnerabilityReport/vulnerabilityReportLayout';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const VulnerabilityReportPage = () => (
  <ContentLayout>
    <VulnerabilityReportContainer>
      <VulnerabilityReportLayout />
    </VulnerabilityReportContainer>
  </ContentLayout>
);

export default VulnerabilityReportPage;
